var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#117E30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4839 16.9295L11.7327 20.798C11.3641 21.047 10.9831 21.0658 10.5899 20.8545C10.1966 20.6432 10 20.3144 10 19.8681V12.1312C10 11.6838 10.1966 11.355 10.5899 11.1447C10.9831 10.9345 11.3641 10.9533 11.7327 11.2013L17.4839 15.0697C17.828 15.2929 18 15.6029 18 15.9996C18 16.3964 17.828 16.7064 17.4839 16.9295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19.8681C20 20.3144 20.1966 20.6432 20.5899 20.8545C21.3926 20.7231 21.5535 20.4686 21.6 19.8681V12.1312C21.4557 11.3329 21.208 11.2249 20.5899 11.1447C20.1966 11.355 20 11.6838 20 12.1312V19.8681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.f5e92a8d94933b33c1d0d8fd731517ce.svg";
export { ForwardRef as ReactComponent };